export const handleClipboardClick = (
  indicationCode: string,
  setIsAnimating: React.Dispatch<React.SetStateAction<boolean>>
) => {
  navigator.clipboard.writeText(indicationCode);
  setIsAnimating(true);
  setTimeout(() => setIsAnimating(false), 3000);
};
